import React from "react";

import "./AmpInlineLoadingSpinner.css";

export default function AmpInlineLoadingSpinner(): JSX.Element{
    return (
        <div className="lds-dual-ring"></div>
    )
}
